import { apiFetch } from './prospects.js';

export async function fetchTags() {
  return apiFetch('/tags');
}

